import 'core-js/proposals/reflect-metadata';

import { Serializable, jsonProperty } from 'ts-serializable';
import UserAddress from '../UserAddress';
import { CompanyHead } from './CompanyHead';
import { boolean } from 'yup/lib/locale';

class Company extends Serializable {

    @jsonProperty(String, null)
    id: string = '';

    @jsonProperty(String, null)
    razaoSocial: string = '';

    @jsonProperty(String, null)
    nomeFantasia: string = '';

    @jsonProperty(String, null)
    cnpj: string = '';

    @jsonProperty([String], null)
    unidadesAtendimento: string[] | null = [];

    @jsonProperty([String], null)
    telefones: string[] | null = [];

    @jsonProperty(Boolean)
    usaClinicFrame: boolean = false;

    @jsonProperty(String, null)
    clinicFrameUrl: string = '';
    
    @jsonProperty(String, null)
    clinicFrameApiUrl: string = '';

    @jsonProperty(Boolean)
    inativo: boolean = false;

    @jsonProperty(UserAddress)
    endereco: UserAddress = new UserAddress();

    @jsonProperty(CompanyHead)
    responsavelEmpresa: CompanyHead = new CompanyHead();

    @jsonProperty(CompanyHead)
    administradorEmpresa: CompanyHead = new CompanyHead();

}

export default Company;